/**
 * Whether it is safe to submit a trade signed by `connectedAddress` under a
 * session bound to `sessionEoaAddress`.
 *
 * Background: incident 2026-08-31 (prome-vault/work/incidents/
 * 2026-08-31-dpin-silent-unattributed-fills.md) — a user switched wallet
 * accounts in their extension while the page session (JWT) stayed on the old
 * account. The on-chain tx was signed and mined by the NEW address, but the
 * backend attributes fills by the session's bound account, so the fill was
 * silently unattributable (no error, no position, no attributed volume).
 *
 * Either address being unknown (wallet not yet connected, or the session's
 * bound address not yet loaded/no session) is NOT treated as a mismatch —
 * those states are already guarded elsewhere (wallet-not-connected checks,
 * isAuthed gates). This only flags the case where both are known and differ.
 */
export const signerMatchesSession = (
  connectedAddress: string | undefined | null,
  sessionEoaAddress: string | undefined | null
): boolean => {
  if (!connectedAddress || !sessionEoaAddress) return true;
  return connectedAddress.toLowerCase() === sessionEoaAddress.toLowerCase();
};
